export default {
	tenantId: "dlvn",
	appId: "covergo_crm",
	fileSystem: {
		bucketName: "dlvn"
	}
}
